const PurchaseOrderActionTypes = {
  SET_PURCHASE_ORDERS: 'SET_PURCHASE_ORDERS',
  REMOVE_PURCHASE_ORDER: 'REMOVE_PURCHASE_ORDER',
  SET_REVERSED_PURCHASE_ORDERS: 'SET_REVERSED_PURCHASE_ORDERS',
};

export default PurchaseOrderActionTypes;
